'use client'

import { FC, useMemo } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { IProgressBarProps } from './types'

const ProgressBar: FC<IProgressBarProps> = ({ totalPercent, className }) => {
  const { clampedProgress, progress } = useMemo(() => {
    return {
      progress: totalPercent,
      clampedProgress: 100 - Math.min(100, Math.max(0, totalPercent ?? 0)),
    }
  }, [totalPercent])

  return (
    <div
      className={`relative w-full max-w-md h-4 bg-gray-200 border border-grayscale-200
      rounded-lg flex items-center justify-center prose-body-small font-semibold text-neutral-black overflow-hidden
      ${progress === 100 ? 'border-status-green' : 'border-grayscale-200'}
      ${className}
      `}
    >
      {progress !== 100 && (
        <Skeleton
          className="skeleton"
          style={{
            position: 'absolute',
            right: 0,
            zIndex: 2,
            width: '100%',
            height: '18px',
            opacity: 0.4,
            borderRadius: '6px',
          }}
          count={1}
          baseColor="#dddddf"
        />
      )}
      <div
        className="absolute right-0 h-full transition-all duration-300 z-[1]"
        style={{
          width: `${clampedProgress}%`,
          background: '#ffffff',
          borderTopRightRadius: '6px', // Arredondamento só no lado direito
          borderBottomRightRadius: '6px',
        }}
      />

      {/* Barra de progresso colorida (sempre ocupa 100% e só é coberta pela camada branca) */}
      <div
        className="absolute left-0 h-full transition-all duration-300 z-0"
        style={{
          width: '100%',
          background: `linear-gradient(to right, #32cd3232 0%, rgba(50, 205, 50, 1) 100%)`,
          borderRadius: '6px', // Mantém bordas arredondadas no container principal
        }}
      />
      <span className="absolute z-10">{progress}%</span>
    </div>
  )
}

export default ProgressBar
